<div id="dashboard-mobile" class="pb-1" *ngIf="isTablet$ | async">
    <div class="menu-container mt-3 mb-1 ps-4">
        <app-burger-menu (expandedState)="displayMenu($event)" menuTitle="About Us Menu">
            <div class="menu-items px-4 py-1" @fadeSlideInOut *ngIf="isMenuCollapsed">
                <div class="item" *ngFor="let item of aboutRoutes">
                    <app-link
                        [attr.data-gtmlabel]="item.name"
                        [appRouterLink]="item.routerLink"
                        class="{{ gtmPrefix + item.routerLink }}"
                        [ngClass]="{ 'accessed-route': checkIfActiveRoute(item.routerLink) }"
                    >
                        {{ item.name }}
                    </app-link>
                </div>
            </div>
        </app-burger-menu>
    </div>
</div>
